import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesInventory } from "./../../constants";
import { DeleteInventoryManagerResponse } from "./deleteInventoryManagers.types";

export const requestDeleteInventoryManager = async (
  inventoryManagerId: string
): Promise<DeleteInventoryManagerResponse> => {
  return await instance.delete(
    buildUrl(ApiRoutesInventory.InventoryManager, inventoryManagerId)
  );
};
